import { Typography } from 'antd';
import { checkForSuperAdmin } from '../../utils/checkRole';

// "First Last", or the email for an account with no name on it
const dealerName = dealer => [dealer.firstName, dealer.lastName].filter(Boolean).join(' ') || dealer.email;

/**
 * Orders table, Super Admins only (SC-QA-90): the dealer who took each order, right after the status, on both the Active
 * and Done tabs. The name is cut to the column with the email in a tooltip; an order nobody has taken shows a dash. A
 * dealer sees only their own orders and the untaken New ones, so nobody else gets the column.
 */
export const withDealerColumn = (columns, { currentUser, t, textStyle }) => {
    if (!checkForSuperAdmin(currentUser)) {
        return columns;
    }

    const dealerColumn = {
        title: t('fields.dealer'),
        dataIndex: 'dealer',
        key: 'dealer',
        width: 180,
        render: dealer => (
            <Typography.Text style={textStyle} ellipsis={dealer ? { tooltip: dealer.email } : false}>
                {dealer ? dealerName(dealer) : '—'}
            </Typography.Text>
        ),
    };
    const statusIndex = columns.findIndex(column => column.key === 'status');

    return [...columns.slice(0, statusIndex + 1), dealerColumn, ...columns.slice(statusIndex + 1)];
};
